import Inputmask from 'inputmask';

export default {
	init
};

export function init() {
	document.querySelectorAll('.format-phone').forEach((el) => {
		new Inputmask({ mask: '(999) 999-9999' }).mask(el as HTMLElement);
	});

	document.querySelectorAll('.format-date').forEach((el) => {
		new Inputmask({
			mask: '99/99/9999',
			placeholder: 'MM/DD/YYYY',
		}).mask(el as HTMLElement);
	});

}

$(init);
